<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.branche_id != null}">
                                        <label for="branche_id" class="bmd-label-floating">Loja</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="branches"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.branche_id">
                                        </model-list-select>
                                        <label v-if="validation.branche_id != null" id="branch_id-error" class="error" for="branche_id">{{ validation.branch_id }}</label>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.administrator_id != null}">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="administrators"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.administrator_id">
                                        </model-list-select>
                                        <label v-if="validation.administrator_id != null" id="administrator_id-error" class="error" for="administrator_id">{{ validation.administrator_id }}</label>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="salesman_id" class="bmd-label-floating">Filtro Data</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="dateFilters"
                                                option-value="id"
                                                option-text="label"
                                                v-model="form.date_filter">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled" >
                                        <label for="interval" class="bmd-label-floating">Intervalo Data</label>
                                        <date-picker
                                                range
                                                v-model="form.interval"
                                                lang="pt-br"
                                                format="DD/MM/YYYY"
                                                placeholder="Escolha uma data"
                                                :not-after="form.end_at"
                                        >
                                        </date-picker>
                                        <label v-if="validation.interval != null" id="interval-error" class="error" for="interval">{{ validation.interval }}</label>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="salesman_id" class="bmd-label-floating">Vendedor</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="salesmenByBranch"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.salesman_id">
                                        </model-list-select>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="installments_order" class="bmd-label-floating">N° da Parcela</label>
                                        <input type="text" class="form-control" placeholder="N° da Parcela" v-model="form.installments_order">
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        computed: {
            administrators: {
                get() {
                    return this.$store.state.administrators.itens;
                }
            },

            branches() {
                return this.$store.state.defaults.branches;
            },

            salesmenByBranch() {
                const self = this;

                return self.salesmans.filter(salesman => salesman.branch_id == self.form.branche_id);
            }
        },
        data() {
            return {
                dateFilters: [
                    { id: 'sale_at', label: 'Data da Venda' },
                    { id: 'deployment_at', label: 'Data Alocação' },
                    { id: 'cancel_at', label: 'Data do Cancelamento' },
                ],
                validation: {
                    interval: null,
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,
                },
                form: {
                    installments_order: null,
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,
                    salesman_id: null,
                    interval: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    end_at: Vue.moment().add(40, 'days'),
                    date_filter: 'sale_at',
                },
                salesmans: [],
            };
        },
        methods: {

            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                //self.getData();
                const response = self.$store.dispatch('administrators/all');

                //
                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getData();
                });
                //
                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getData() {
                var self = this;
                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('commissions/typesOfcommissions');
                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getDataTeams();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataTeams();
                });
            },
            onReset() {
                this.form = {
                    administrator_id : null,
                    branche_id: null,
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    interval: null,
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,

                };

                if (!self.form.interval[0] || !self.form.interval[1]) {
                    valid = false;
                    self.validation.interval = 'Favor informar o intervalo desejado!';
                }

                if (valid) {
                    var serialize = JSON.stringify(self.form);
                    window.open("print-non-payment-montly?form=" + serialize, '_blank');
                }
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getUsers();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getUsers();
                });
            },
            async getUsers(_param) {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('users/all', _param);

                response.then(function (x) {
                    self.salesmans = x;
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
        },
        created() {
            var self = this;
            self.getDataAdministrators();
        }
    }
</script>
